<template>
  <div
    class="dropdown is-right"
    :class="open === true ? 'is-active' : null"
    :tabindex="tabindex"
  >
    <div
      class="button"
      aria-haspopup="true"
      aria-controls="dropdown-menu"
      :class="{ open: open }"
      @click="open = !open"
    >
      <img src="../assets/img/translate-icon-purple.svg" class="translate-icon" alt="Translate icon"/>
      
      <span>{{ getSelectedLanguage }}</span>
      <span class="icon is-small">
        <i class="fas fa-angle-down" aria-hidden="true"></i>
      </span>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <router-link
          v-for="(option, i) of options"
          :key="i"
          :to="option.routerlink"
          class="dropdown-item"
          :class="getSelectedLanguage === option.language ? 'is-active' : null"
          @click="
            selected = option.name;
            open = false;
            $emit('input', option);
            selectedLanguageAction(option.language);
          "
        >
          {{ option.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
    };
  },
  mounted() {
    this.$emit("input", this.selected);
  },
  computed: {
    ...mapGetters(["getSelectedLanguage"]),
  },
  methods: {
    ...mapActions(["selectedLanguageAction"]),
  },
  created: function () {
    let self = this;

    window.addEventListener("click", function (e) {
      // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.open = false;
      }
    });
  },
};
</script>

<style scoped>
.button {
  border: 1px solid var(--getty-grey-3);
  display: flex;
  align-items: center;
}

.translate-icon{
  margin-right: 10px;
  width: 1.2rem;
  color: var(--getty-purple);
}

.button span:nth-child(2) {
  margin-right: 10px;
}

.button span:last-child {
  border-left: 1px solid var(--getty-grey-3);
}

.fa-language {
  color: var(--primary-color);
  font-size: 27px;
  opacity: 1;
  margin-left: 0;
}

.dropdown-content a.dropdown-item.is-active,
.dropdown-content button.dropdown-item.is-active {
  background-color: transparent;
  color: var(--primary-color);
}

@media (max-width: 734px) {
  .button span:first-child {
    display: none;
  }
  .button span:nth-child(2) {
    margin-right: 5px;
  }
}
</style>